<template>
  <div>
    <wc-page-title title='Chart of Accounts'
      showAdd
      @add='editRow'
    ></wc-page-title>
    <v-container>
      <wc-data-box hideToolbar>
        <v-data-table
          dense
          :items='accounts'
          :headers='headers'
          :items-per-page='-1'
          hide-default-footer
          @click:row='editRow'
        >
          <template v-slot:item.number='{ item }'>
            {{ item .number }} <small class='grey--text'>{{ item.account_type_display}}</small>
          </template>
          <template v-slot:item.name='{ item }'>
            <span v-if='item.is_grouping'>
              <strong class='text-uppercase'>{{ item.name }}</strong>
            </span>
            <span v-else>
              <span v-if='item.grouping' class='ml-6'>{{ item.name }}</span>
              <span v-else>{{ item.name }}</span>
            </span>
          </template>
        </v-data-table>
      </wc-data-box>
    </v-container>



    <!-- Edit/Add Account --> 
    <wc-dialog
      title='Account Details'
      width='400'
      :disableButtons='!isFormValid || is_duplicate_number'
      :showDialog='showEditDialog'
      :icon='$store.state.icons.modules.chartOfAccounts.icon'
      :loadingButtons='isSaving'
      @cancel='showEditDialog = false'
      @save='saveAccount'
    >
    <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          label='Account Name'
          v-model='accountCopy.name'
          :rules='[rules.required]'
        ></v-text-field>
        <v-text-field
          label='Account Number'
          v-model='accountCopy.number'
          :rules='[rules.required]'
        ></v-text-field>
        <v-select
          :items='account_types'
          item-text='name'
          item-value='id'
          label='Account Type'
          v-model='accountCopy.account_type'
          :rules='[rules.required]'
        ></v-select>
        <v-select
          :items='account_groups'
          item-text='name'
          item-value='id'
          label='Account Group'
          v-model='accountCopy.account_group'
          :rules='[rules.required]'
        ></v-select>
        <v-checkbox
          label='Is this a credit card?'
          v-model='accountCopy.is_credit_card'
        ></v-checkbox>
        <v-checkbox
          label='Requires Reconciliation?'
          v-model='accountCopy.requires_reconciliation'
        ></v-checkbox>
        <v-checkbox
          label='Can Deposit?'
          v-model='accountCopy.can_deposit'
        ></v-checkbox>
        <v-checkbox
          label='Can Pay With?'
          v-model='accountCopy.can_pay_with'
        ></v-checkbox>
        <v-select
          :items='divisions'
          item-text='division'
          item-value='id'
          label='Division'
          v-model='accountCopy.division'
        ></v-select>
      </v-form>
      <v-alert type='error' border='left' v-if='is_duplicate_number'>Account number already exists.</v-alert>
    </wc-dialog>



    <!-- Cannot Edit -->
    <wc-dialog
      title='Cannot Edit'
      :showDialog='showCannotEdit'
      :icon='$store.state.icons.modules.chartOfAccounts.icon'
      width='350'
      hideCancel
      saveText='OK'
      @save='showCannotEdit = false'
    >
      <strong>{{ accountCopy.name }}</strong><br>
      {{ accountCopy.number }}
      <span class='grey--text'>{{ accountCopy.account_type_display }}</span>
      <br>
      <br>
      This is a system account and cannot be edited.
    </wc-dialog>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import miscServices from '@/services/misc';
import formRules from '@/mixins/formRules';
import _ from 'lodash';

export default {
  name: 'chart-of-accounts',
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    isSaving: false,
    isFormValid: false,
    showEditDialog: false,
    showCannotEdit: false,
    accounts: [],
    accoung_groups: [],
    accountCopy: {},
    headers: [
      { text: 'Nummber', value: 'number', width: 150 },
      { text: 'Name', value: 'name' }
    ],
    account_types: [
      {
        "name": "Asset",
        "id": "A"
      },
      {
        "name": "Liability",
        "id": "L"
      },
      {
        "name": "Equity",
        "id": "Q"
      },
      {
        "name": "Revenue",
        "id": "R"
      },
      {
        "name": "Expense",
        "id": "E"
      }
    ],
  }),
  computed: {
    is_duplicate_number () {
      let tmp = _.filter(this.accounts, a => a.number === parseInt(this.accountCopy.number))
      let is_dup = false

      tmp.forEach(a => {
        if (a.number == this.accountCopy.number && a.id !== this.accountCopy.id) {
          is_dup = true;
        }
      })
      return is_dup;
    },
    grouping_accounts () {
      return this.accounts.filter(a => a.is_grouping === true)
    },
    divisions () {
      return this.$store.state.misc.divisions
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true;
      this.accounts = await accountingAPI.getAccounts();
      this.account_groups = await accountingAPI.getAccountGroups();
      this.isLoading = false;
    },
    resetCopy () {
      this.accountCopy = {
        id: null,
        number: 0,
        name: '',
        account_type: '',
        is_grouping: false,
        grouping: null
      }
    },
    editRow (line = null) {
      if (line) {
        this.accountCopy = _.cloneDeep(line)
        if (this.accountCopy.system_account == false) {
          this.showEditDialog = true
        } else {
          this.showCannotEdit = true
        }
      } else {
        this.resetCopy()
        this.showEditDialog = true
        this.$nextTick(() => {
          this.$refs.form.resetValidation()
        })
      }
    },
    async saveAccount () {
      this.isSaving = true
      if (this.accountCopy.id) {
        this.accountCopy = await accountingAPI.updateAccount(this.accountCopy.id, this.accountCopy)
        this.accounts = miscServices.replaceObject(this.accounts, this.accountCopy)
      } else {
        this.accounts.push(await accountingAPI.createAccount(this.accountCopy))
      }
      this.isSaving = false
      this.showEditDialog = false
    }
  }
}
</script>
